export default __webpack_public_path__ + "static/media/water.6651f11a.png";